import { Component, Input, OnInit } from '@angular/core';
import { AppContentfulArticlesListComponent } from '../contentful-articles-list/contentful-articles-list.component';
import { ContentfulArticleContent } from 'src/app/core/interfaces/Contentful/Article/ContentfulArticleContent';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';

@Component({
  selector: 'app-contentful-related-articles',
  templateUrl: './contentful-related-articles.component.html',
  styleUrls: ['./contentful-related-articles.component.scss'],
  standalone: true,
  imports: [AppContentfulArticlesListComponent],
})
export class AppContentfulRelatedArticlesComponent implements OnInit {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;
  contentfulRelatedArticlesContent: Array<ContentfulArticleContent> = [];

  ngOnInit(): void {
    if (this.contentfulSectionContent) {
      // @TODO: Check how we can differ the different contentful content types without using this any
      const contentfulSectionContent = this.contentfulSectionContent.contentfulContent?.content as any;

      if (contentfulSectionContent && contentfulSectionContent.contents) {
        this.contentfulRelatedArticlesContent.push(contentfulSectionContent);
      }
    }
  }
}
